import { render, staticRenderFns } from "./StudentTheoryDetail.vue?vue&type=template&id=993ed3ec&scoped=true"
import script from "./StudentTheoryDetail.vue?vue&type=script&lang=js"
export * from "./StudentTheoryDetail.vue?vue&type=script&lang=js"
import style0 from "./StudentTheoryDetail.vue?vue&type=style&index=0&id=993ed3ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993ed3ec",
  null
  
)

export default component.exports